<template>
	<section class="container-fluid">
		<div class="row">
			<div class="col-12">
				<h1>Plans</h1>
			</div>
		</div>
		<div v-if="plans" class="row">
			<div class="col-12 options">
				<div class="row options-bar">
					<button class="add-item" @click="openAddModal">Add plan <i class="ss-plus ss-glyphish-filled"></i></button>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<List :plans="plans" @edit="editPlan" @delete="deletePlan"/>
			</div>
		</div>
		<Add v-if="addOpen" @close="addOpen = false"/>
		<Edit v-if="editOpen" @close="editOpen = false" :plan="selected"/>
		<Delete v-if="deleteOpen" @close="deleteOpen = false" :plan="selected"/>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import List from '../Plans/List.vue'
import Add from '../Plans/Add.vue'
import Edit from '../Plans/Edit.vue'
import Delete from '../Plans/Delete.vue'

export default {
		components: {
		List,
		Add,
		Edit,
		Delete,
	},
	data() {
		return {
			selected: null,
			deleteOpen: false,
			editOpen: false,
			addOpen: false,
		}
	},
	computed : {
		...mapState({
			plans : state => state.plans.list,
		}),
	},
	methods: {
		openAddModal() {
			this.addOpen = true
		},
		deletePlan(plan) {
			this.selected = plan
			this.deleteOpen = true
		},
		editPlan(plan) {
			this.selected = plan
			this.editOpen = true
		},
	},
	mounted() {
		this.$store.dispatch('plans/getList')
		.then(() => {
			this.$store.commit('app/setLoading', false)
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false)
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Pages/Plans.vue